import { render, staticRenderFns } from "./customerStatement.vue?vue&type=template&id=243da422&"
import script from "./customerStatement.vue?vue&type=script&lang=js&"
export * from "./customerStatement.vue?vue&type=script&lang=js&"
import style0 from "./customerStatement.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports